import packageJson from '../../../package'

export default {
	COPYRIGHT: 'Todos os direitos reservados',
	LINK_ARQUIVO: '/api',
	NOME: 'ata-registro-preco',
	PARAMETRO_NAMESPACE: 'az.ata-registro-preco',
	VERSAO: packageJson.version,
}
